module.exports = __webpack_public_path__ + "static/default-c41e655f679eb7ea591577e6aceafb25.png";